module.exports = __webpack_public_path__ + "img/party-2016-congress.cd882186.jpg";